import React from "react";
import { ParameterActions } from "../actions";

const defaultState = {
  definedParameters: false,
  posFixado: null,
  creditoPrivado: null,
  multimercado: null,
  rendaVariavelGlobal: null,
  rendaFixaGlobal: null,
  rendaVariavel: null,
};

const parametersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ParameterActions.SetParameters:
      return action.payload;
    default:
      return state;
  }
};

export default parametersReducer;
